<template>
  <div class="pb-6">
    <div class="flex flex-wrap" v-if="tags && tags.length">

      <div
        class="tag-tile text-lg font-mono pb-2 pt-3 px-2 text-dark-teal bg-white rounded-sm font-bold flex flex-col justify-between cursor-pointer text-dark-teal font-bold"
        @click.prevent="$emit('select', t)"
        v-for="t in tags">
        <span v-html="parsedSymbol('#' + t)"></span>
      </div>
    </div>
    <div v-else>No <strong>Tags</strong> to select</div>
  </div>
</template>

<script>
 import {mapState} from 'vuex';

 export default {
   props: {
     filterList: {
       type: Array,
       default: () => []
     }
   },

   computed: mapState({
     tags: function(state) {
       return state.tagList.filter(tl => !this.filterList.some(t => tl === t))
     }
   }),

   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   }
 }
</script>

<style scoped>
 .tag-tile {
   width: 30%;
   margin-right: 5%;
   margin-bottom: 40px;
   min-height: 50px;
   word-wrap: anywhere;
 }

 
 .tag-tile:nth-child(3n+3) {
   margin-right: 0;
 }


 .count {
   background: rgba(0,0,0,.25);
   padding: 5px;
   min-width: 25px;
   text-align: center;
 }
</style>


